<template>
  <v-navigation-drawer
    v-model="drawer"
    temporary
    right
    width="450"
    height="100%"
    app
  >
    <v-card
      flat
      :loading="loading"
    >
      <v-card-title>
        <v-row>
          <v-col cols="12">
            <v-icon @click="drawer = false"> close </v-icon>
          </v-col>
          <v-col> {{ title }} </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-autocomplete
          v-model="addCoreProductId"
          dense
          :items="products"
          item-text="name"
          item-value="id"
          label="Add Core Product"
          outlined
          clearable
          @change="addCoreProduct"
        />
        <v-checkbox
          v-for="item in productsToShow"
          :key="item.id"
          v-model="selected"
          class="pt-0 mt-0"
          :value="item.id"
          :label="item.name"
          :disabled="item.disabled"
        />
      </v-card-text>
    </v-card>
    <template #append>
      <div class="px-3 py-5">
        <v-btn
          color="primary"
          block
          large
          :loading="saving"
          :disabled="!selected.length"
          @click="save"
        >
          Save
        </v-btn>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex';
import { uniq, intersection, cloneDeep } from 'lodash';
export default {
  name: 'TemplateCopy',
  components: {},
  data() {
    return {
      loading: false,
      valid: false,
      drawer: false,
      saving: false,
      selected: [],
      templateIds: [],
      overrideCoreProductIds: [],
      addCoreProductId: null
    };
  },

  computed: {
    title() {
      let val = `${this.templates.length} Templates`;
      if (this.templates.length === 1) {
        val = `"${this.templates[0].name}"`;
      }
      return `Copy ${val}`;
    },
    productsToShow() {
      return cloneDeep(this.products)
        .filter(
          (x) =>
            (x.active && !x.mcsDisabled && this.coreProductsToUse.includes(x.id)) ||
            this.overrideCoreProductIds.includes(x.id)
        )
        .map((x) =>
          Object.assign(x, {
            disabled:
              this.coreProductIds.includes(x.id) || this.resizedToCoreProductIds.includes(x.id)
          })
        );
    },
    coreProductsToUse() {
      const product = this.products.find((x) => x.id === this.coreProductId);
      const val = product ? product.resizeCoreProductIds || [] : [];
      return val.concat([this.coreProductId]);
    },
    coreProductIds() {
      return uniq(this.templates.map((x) => x.coreProductId));
    },
    resizedToCoreProductIds() {
      return uniq(this.templates.flatMap((x) => x.resizedToCoreProductIds || []));
    },
    resizeDefaultCoreProductIds() {
      const arrays = this.templates.map((x) => x.resizeDefaultCoreProductIds);
      return intersection(...arrays);
    },
    coreProductId() {
      return this.templates.map((x) => x.coreProductId)[0];
    },
    templates() {
      let list = this.$store.getters['templates/list'].filter((x) =>
        this.templateIds.includes(x.id)
      );
      if (!list.length) {
        list = this.$store.getters['templates/copy'].filter((x) => this.templateIds.includes(x.id));
      }
      return list;
    },
    ...mapGetters({
      products: 'lookup/standard_products'
    })
  },

  mounted() {
    this.$bus.$off(this.$enums.EVENT_BUS_EVENTS.COPY_TEMPLATE_SHOW);
    this.$bus.$on(this.$enums.EVENT_BUS_EVENTS.COPY_TEMPLATE_SHOW, (data) => {
      this.show(data);
    });
  },

  methods: {
    show(data) {
      this.overrideCoreProductIds = [];
      this.templateIds = data.templateIds;
      this.selected = this.productsToShow
        .filter((x) => this.resizeDefaultCoreProductIds.includes(x.id) && !x.disabled)
        .map((x) => x.id);
      this.drawer = true;
    },
    save() {
      this.saving = true;
      this.$store
        .dispatch('templates/copy', {
          templateIds: this.templateIds,
          coreProductIds: this.selected
        })
        .then(() => {
          this.$emit('save');
          this.$root.$snackbarSuccess('Templates copied');
          this.drawer = false;
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    },
    addCoreProduct() {
      if (this.addCoreProductId) {
        this.overrideCoreProductIds.push(this.addCoreProductId);
        this.$nextTick(() => {
          this.addCoreProductId = null;
        });
      }
    }
  }
};
</script>
